import styled from "styled-components";

const ModalCustomAvisos = styled.div`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  width:82%;
  position: fixed; 
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%); 
  background: ${(props) => (props.background ? "rgba(0, 0, 0, 0)" : "white")};
  align-items: center;
  overflow: auto; 
  max-height: 90vh; 
  padding: 20px; 
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); 
`;

export default ModalCustomAvisos;